import EditCompanyModal from './EditCompanyModal';

export default EditCompanyModal;
